import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

interface Props {
  maxHeight?: number;
  maxWidth?: number;
  minHeight?: number;
  minWidth?: number;
  height?: number;
  width?: number;
  children: ReactNode;
}

const BoundedBox = (props: Props) => (
  <Box
    style={{
      maxHeight: props.maxHeight,
      maxWidth: props.maxWidth,
      minHeight: props.minHeight,
      minWidth: props.minWidth,
      height: props.height,
      width: props.width,
    }}
  >
    {props.children}
  </Box>
);

export default BoundedBox;
